import React from "react";
import styled from "styled-components";
import titleSvg from "../img/title-map.svg";
import mapPng from "../img/map.png";
import device from "../helpers/device";

export default function({ ...props }) {
  return (
    <Root {...props}>
      <Title>
        <img src={titleSvg} alt="MAP" />
      </Title>
      <Map>
        <img src={mapPng} alt="" />
      </Map>
    </Root>
  );
}

const Root = styled.div`
  margin-top: 50px;
  @media ${device.mobileL} {
    margin-top: 100px;
  }
`;

const Title = styled.h2`
  text-align: center;
  margin-bottom: 60px;
  img {
    width: 73px;
  }
`;

const Map = styled.div`
  text-align: center;
  padding: 0 20px;
  @media ${device.mobileL} {
    padding: 0 80px;
  }
  img {
    width: 100%;
  }
`;
